module.exports = __webpack_public_path__ + "static/media/snowing.1f99ece5.gif";